import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { EstimateSettings } from '@/types/settings';
import { useHasAnyPermission } from '@/hooks/usePermissions';

interface UseEstimateSettingsOptions {
  enabled?: boolean;
}

export function useEstimateSettings(options: UseEstimateSettingsOptions = {}) {
  const canViewEstimateSettings = useHasAnyPermission('company:view', 'estimates:view');
  const query = useApiQuery<EstimateSettings>({
    queryKey: settingsKeys.estimateSettings(),
    queryFn: () => apiGet<EstimateSettings>(operationsClient, settingsEndpoints.estimateSettings()),
    enabled: canViewEstimateSettings && (options.enabled ?? true),
    showErrorToast: false,
  });
  return canViewEstimateSettings ? query : { ...query, data: undefined };
}
